import { styled } from '@/stitches.config';
import { Box } from '@components';
import { CSS } from '@stitches/react';

export const StyledRow = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const StyledDiseaseTitle = styled('span', {
  fontSize: '$sm',
  fontWeight: '$bold',
  textTransform: 'uppercase',
  color: '$darkBlue400',
  textAlign: 'start',
  lineHeight: '$4',
});

export const StyledNoDataMessage = styled('span', {
  color: '$darkGray400',
  fontSize: '$lg',
  fontWeight: '$medium',
  textAlign: 'left',
});

export const infoCardStyles: CSS = {
  borderRadius: '$radii$4',
  flexDirection: 'column',
  padding: '$8',
  width: '32%',
};
